// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__UkNkn","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__13EOp"};